import { render, staticRenderFns } from "./Scly.vue?vue&type=template&id=6bc233f7&scoped=true"
import script from "./Scly.vue?vue&type=script&lang=js"
export * from "./Scly.vue?vue&type=script&lang=js"
import style0 from "./Scly.vue?vue&type=style&index=0&id=6bc233f7&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc233f7",
  null
  
)

export default component.exports